import { localMapApi } from '@src/api'
import { type BridgeInfoType } from '@src/bridge/context/BridgeInfoProvider'
import { type LocalMapServiceCreateUserLocationRequest } from '@src/network/src/__gen__/local-map'

export type CreateUserLocationProps = {
  bridgeInfo: BridgeInfoType
  data: LocalMapServiceCreateUserLocationRequest
}

export type CreateUserLocationResponse = ReturnType<typeof createUserLocation>

export function createUserLocation({
  bridgeInfo,
  data,
}: CreateUserLocationProps) {
  return localMapApi(bridgeInfo).localMapServiceCreateUserLocation(data)
}
